import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RowLayoutComponent } from './row-layout/row-layout.component';
import { BoxLayoutComponent } from './row-layout/box-layout/box-layout.component';
import { FrontBannerComponent } from './row-layout/front-banner/front-banner.component';
import { NgImageSliderModule } from 'ng-image-slider';



@NgModule({
  declarations: [
    RowLayoutComponent, 
    BoxLayoutComponent, FrontBannerComponent
  ],
  imports: [
    CommonModule,
    NgImageSliderModule
  ],
  exports: [
    RowLayoutComponent
  ]
})
export class BasicLayoutModule { }
